module.exports = __webpack_public_path__ + "static/img/316.f592497.png";